import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "desktop-draws-section" }
const _hoisted_2 = { class: "desktop-draws-content" }
const _hoisted_3 = { class: "desktop-draws-grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "desktop-draw-content" }
const _hoisted_6 = { class: "desktop-draw-info" }
const _hoisted_7 = { class: "desktop-draw-date" }
const _hoisted_8 = { class: "desktop-draw-time" }
const _hoisted_9 = ["checked", "onChange"]
const _hoisted_10 = { class: "desktop-quick-actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]

import { computed, watch } from 'vue';


const __default__ = {
  name: "DesktopDrawsSection",
};

interface Draw {
  event_id: string | number;
  draw_date: string;
}

interface Props {
  draws: Draw[];
  selectedDraws: boolean[];
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    draws: {},
    selectedDraws: {}
  },
  emits: ["update-selected-draws", "toggle-draw-selection"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Computed properties
const selectedCount = computed(() => {
  return props.selectedDraws.filter(Boolean).length;
});

const allSelected = computed(() => {
  return props.selectedDraws.every(Boolean);
});

// Methods
// Ensure at least one draw is always selected
const ensureMinimumSelection = () => {
  const selectedCount = props.selectedDraws.filter(Boolean).length;
  if (selectedCount === 0 && props.draws.length > 0) {
    // Select the first draw if none are selected
    emit('update-selected-draws', 0, true);
  }
};

// Watch for changes in selectedDraws to ensure minimum selection
watch(() => props.selectedDraws, () => {
  ensureMinimumSelection();
}, { immediate: true });

const toggleDrawSelection = (index: number) => {
  emit('toggle-draw-selection', index);
};

const handleCheckboxChange = (index: number, event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update-selected-draws', index, target.checked);
};

const selectAll = () => {
  props.draws.forEach((_, index) => {
    if (!props.selectedDraws[index]) {
      emit('update-selected-draws', index, true);
    }
  });
};

const clearAll = () => {
  // Only clear if there are multiple draws selected
  // Keep at least one draw selected
  const selectedIndices = props.selectedDraws
    .map((selected, index) => selected ? index : -1)
    .filter(index => index !== -1);
  
  if (selectedIndices.length > 1) {
    // Clear all except the first one
    selectedIndices.slice(1).forEach(index => {
      emit('update-selected-draws', index, false);
    });
  }
};

const formatDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "desktop-draws-header" }, [
      _createElementVNode("h2", { class: "desktop-section-title" }, "1. Select Draws")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.draws, (draw, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: draw.event_id,
            class: _normalizeClass(["desktop-draw-item", { 'selected': props.selectedDraws[index] }]),
            onClick: ($event: any) => (toggleDrawSelection(index))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "desktop-time-icon" }, [
                _createElementVNode("img", {
                  src: "/img/icons/timer.png",
                  alt: "Time"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(formatDate(new Date(draw.draw_date))), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(formatTime(new Date(draw.draw_date))), 1)
              ])
            ]),
            _createElementVNode("label", {
              class: "desktop-checkbox-wrapper",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: props.selectedDraws[index],
                onChange: ($event: any) => (handleCheckboxChange(index, $event))
              }, null, 40, _hoisted_9),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "desktop-checkmark" }, null, -1))
            ])
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "desktop-action-btn primary",
          onClick: selectAll,
          disabled: allSelected.value
        }, " Select All ", 8, _hoisted_11),
        _createElementVNode("button", {
          class: "desktop-action-btn secondary",
          onClick: clearAll,
          disabled: selectedCount.value <= 1
        }, " Clear All ", 8, _hoisted_12)
      ])
    ])
  ]))
}
}

})